import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
/* Styles */
import "../style/pages/home.css";
import "core-js/modules/es.array.iterator";
//@ts-ignore
import { createApp, defineAsyncComponent } from "vue";
//@ts-ignore
import SearchMobile from "./vue/SearchMobile.vue";
//@ts-ignore
import axios from "axios";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import { Modals } from "./Types/Modals";
//@ts-ignore
import commonAsyncComponents from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import SearchBoxHome from "./vue/SearchBoxHome";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import { createPinia, mapActions, mapState } from "pinia";
import { useBaseStore, useModalStore, useEmailConfirmStore, usePublicUserMenuStore, useLoggedUserStore, useHomeTabStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import BaseBadge from "@vueEntry/UIKitComponents/BaseBadge.vue";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { isiOSDevice as checkIfiOSDevice } from "@utils/DeviceDetection";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
//@ts-ignore
import { sendGAEvent } from "@utils/GaEvents";
// import {SwiperCarousel, SwiperSlide} from "@wikicasa-dev/components";
//@ts-ignore
import SwiperSlide from "@vueEntry/SwiperCarousel/SwiperSlide.vue";
//@ts-ignore
import SwiperCarousel from "@vueEntry/SwiperCarousel.vue";
var homeApp = createApp({
  name: "WikiHome",
  components: Object.assign(Object.assign(Object.assign({
    BaseButton: BaseButton,
    PublicUserMenu: PublicUserMenu,
    SearchMobile: SearchMobile,
    SearchBoxHome: SearchBoxHome,
    SwiperCarousel: SwiperCarousel,
    SwiperSlide: SwiperSlide,
    BaseBadge: BaseBadge
  }, commonAsyncComponents), {
    //@ts-ignore
    "place-modal": defineAsyncComponent(function () {
      return import("@vmodals/PlaceModal.vue");
    }),
    //@ts-ignore
    "base-bt-modal": defineAsyncComponent(function () {
      return import("@vueEntry/BaseBtModal.vue");
    }),
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(function () {
      return import("@vueEntry/UIKitComponents/BaseDropDown.vue");
    })
  }), LanguageIcons),
  setup: function setup() {
    var _useBreakpoints = useBreakpoints(),
      isDesktopMode = _useBreakpoints.isDesktopMode,
      isSmall = _useBreakpoints.isSmall,
      isLarge = _useBreakpoints.isLarge;
    var _useAppBanner = useAppBanner(),
      isAppBannerVisible = _useAppBanner.isAppBannerVisible;
    var _useFirebaseMessaging = useFirebaseMessaging(),
      showFirebaseSnackbar = _useFirebaseMessaging.showFirebaseSnackbar,
      snackbarTitle = _useFirebaseMessaging.snackbarTitle,
      snackbarBody = _useFirebaseMessaging.snackbarBody,
      snackbarIcon = _useFirebaseMessaging.snackbarIcon,
      handleOnForegroundNotificationClick = _useFirebaseMessaging.handleOnForegroundNotificationClick;
    useTrustpilotWidget();
    var _useUtilities = useUtilities(),
      redirectTo = _useUtilities.redirectTo;
    return {
      isDesktopMode: isDesktopMode,
      isSmall: isSmall,
      isLarge: isLarge,
      isAppBannerVisible: isAppBannerVisible,
      //useFirebaseMessaging
      showFirebaseSnackbar: showFirebaseSnackbar,
      snackbarTitle: snackbarTitle,
      snackbarBody: snackbarBody,
      snackbarIcon: snackbarIcon,
      handleOnForegroundNotificationClick: handleOnForegroundNotificationClick,
      redirectTo: redirectTo
    };
  },
  data: function data() {
    return {
      showUsernameAliasModal: false,
      publicUserConfirmed: false,
      publicUserFailedConfirm: false,
      mailAlertSuccess: true,
      showMessageSentSuccess: false,
      isAgencyActiveHome: false,
      isAuctionActiveHome: false,
      showAllFranchise: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    iOSDevice: function iOSDevice() {
      return checkIfiOSDevice();
    },
    mobileOsIconUrl: function mobileOsIconUrl() {
      return this.iOSDevice ? "".concat(window["_cdn"], "/_ui/img/Icons/apple-logo-blue.svg") : "".concat(window["_cdn"], "/_ui/img/Icons/android-logo-blue.svg");
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name", "lastLoginDate", "email"])), mapState(useEmailConfirmStore, ["passwordToken", "publicUserEmailConfirmSuccess"])), mapState(useModalStore, ["showModal"])), mapState(useHomeTabStore, ["activeTab"])),
  beforeCreate: function beforeCreate() {
    //Removing the redirect url if the user reloads the page!
    window.addEventListener("beforeunload", function (event) {
      localStorage.removeItem("redirect");
    });
  },
  created: function created() {
    var _this = this;
    this.initPublicUserMenu().then(function () {
      _this.publicUserConfirmed = window._publicUserConfirmed;
      _this.publicUserFailedConfirm = window._publicUserFailedConfirm;
      if (!_this.isUserLogged) return;
      if (!_this.lastLoginDate) return;
      var dateNow = new Date();
      var lastLoginDate = new Date(_this.lastLoginDate);
      import("date-fns/differenceInDays").then(function (differenceInDaysModule) {
        var differenceInDays = differenceInDaysModule["default"];
        var daysToLastLogin = differenceInDays(dateNow, lastLoginDate);
        if (daysToLastLogin > 15) axios.get("".concat(window._baseURL, "/rest/publicUser/updateUserLastLoginDate"));
      });
    });
    //Inserting the token
    this.setPasswordToken();
    var curURL = window.location.href;
    //In case there is not a query string, the resultant object will be just empty
    var searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("action") === "login") {
      //cleaning up the home url...
      var redirectUrl = searchParams.get("redirect");
      redirectUrl && localStorage.setItem("redirect", redirectUrl);
      history.pushState(null, "", "/");
      this.setShowModal(Modals.loginModal);
      return;
    }
    if (curURL.includes("recupero-password")) {
      this.setShowModal(Modals.setPwdModal);
    } else if (curURL.includes("conferma-email")) {
      this.setShowModal(Modals.mailConfirmedModal);
    } else this.setShowModal(Modals.noModal);
    if (window["_confirmedUsernameAlias"]) {
      this.showUsernameAliasModal = true;
    }
  },
  methods: Object.assign(Object.assign(Object.assign({
    goToStore: function goToStore() {
      window.location.replace(this.iOSDevice ? "https://apps.apple.com/it/app/wikicasa/id1626038379" : "https://play.google.com/store/apps/details?id=it.wikicasa.wikicasa_app");
      window.dataLayer.push({
        //GA4
        "event_name": "open_store",
        "event_location": "Home",
        "OS": this.iOSDevice ? "ios" : "android"
      });
    },
    cleanToken: function cleanToken() {
      this.setPasswordToken("");
      this.setShowModal(Modals.updatePwdModal);
    },
    triggerPublishEventAndRedirect: function triggerPublishEventAndRedirect(url) {
      sendGAEvent("home_publish_banner_click", {
        event_location: "Home"
      });
      location.href = url;
    }
  }, mapActions(useBaseStore, ["initPublicUserMenu"])), mapActions(useEmailConfirmStore, ["setPasswordToken"])), mapActions(useModalStore, ["setShowModal"]))
});
homeApp.use(createPinia());
homeApp.mount("#home-container");